import ArticleAltmetric from "@/src/components/journal-site/articles/article-sidebar/article-altmetric/article-altmetric";
import ArticleCitationFiles from "@/src/components/journal-site/articles/article-sidebar/article-citation-files/article-citation-files";
import ArticleCitedBy from "@/src/components/journal-site/articles/article-sidebar/article-cited-by/article-cited-by";
import ArticleComments from "@/src/components/journal-site/articles/article-sidebar/article-comments/article-comments";
import ArticleIndexingSources from "@/src/components/journal-site/articles/article-sidebar/article-indexing-sources/article-indexing-sources";
import ArticleMetrics from "@/src/components/journal-site/articles/article-sidebar/article-metrics/article-metrics";
import ArticleShareButtons from "@/src/components/journal-site/articles/article-share-buttons/article-share-buttons";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import ArticleDownloadBox from "./article-download-box/article-download-box";
import { Box } from "@mui/material";
import type ArticleSidebarProps from "@/src/_types/Article/article-sidebar";

const ArticleSidebar = ({
  data,
  journal,
  publisher,
  journalAbbr,
  articleId,
  hasPlumx,
  citation,
}: ArticleSidebarProps) => {
  return (
    <Box>
      <ArticleDownloadBox
        data={{
          id: data?.id,
          pdf_file: data?.pdf_file,
          pdf_file_size: data?.pdf_file_size,
          feature_audio: data?.feature_audio,
          feature_video: data?.feature_video,
          feature_slide: data?.feature_slide,
          supplementary_material: data?.supplementary_material,
          abstract_xml: data?.abstract_xml,
          opr_pdf: data?.opr_pdf,
          opr_pdf_size: data?.opr_pdf_size,
        }}
        journalAbbr={journalAbbr}
        articleId={articleId}
      />
      <ArticleCitationFiles
        article={data as Article}
        journal={journal}
        publisher={publisher}
        journalAbbr={journalAbbr}
        articleId={articleId}
      />
      <Box>
        <StyledDivider label={"Share"} />
        <ArticleShareButtons />
      </Box>
      <ArticleCitedBy
        citation={citation}
        journalAbbr={journalAbbr}
        articleId={articleId}
      />
      {(data?.publon_badge || hasPlumx) && (
        <ArticleMetrics
          publonBadge={data?.publon_badge ?? false}
          doi={data?.doi || ""}
          hasPlumx={hasPlumx ?? false}
        />
      )}
      {data?.has_altmetric && <ArticleAltmetric doi={data?.doi || ""} />}
      <ArticleComments comments={data?.comments || []} />
      {data?.indexing_source && data?.indexing_source.length > 0 && (
        <ArticleIndexingSources indexingSources={data?.indexing_source} />
      )}
    </Box>
  );
};

export default ArticleSidebar;
